import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import IngestPage from "@/pages/Ingest";
import LibraryPage from "@/pages/Library";
import DetailPage from "@/pages/Detail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<IngestPage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/r/:id" element={<DetailPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
